module.exports = __webpack_public_path__ + "img/facebook.f5956a83.svg";